import angular from 'angular';
import paginatedSearchAndSelectDirective from './paginated-search-and-select.directive';

let PaginatedSearchAndSelectModule = angular.module('paginated-search-and-select-module', [])

    .directive('paginatedSearchAndSelect', paginatedSearchAndSelectDirective)

    .name;

export default PaginatedSearchAndSelectModule;


// WEBPACK FOOTER //
// ./client/app/common/paginated-search-and-select/index.js